import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './ProgramTimeline.css';
import Marker from '../../assets/elements/marker.svg'; // Import timeline marker icon
import SmallGradientButton from '../ui/SmallGradientButton/SmallGradientButton';
import LocationBadge from '../ui/LocationBadge/LocationBadge';

interface ProgramEvent {
  date: string; // Display string (e.g., "5th April")
  dateOfEvent: string; // Actual date (e.g., "2025-04-05")
  time?: string;
  title: string;
  description?: string;
  status?: string;
  location: string;
  locationLink: string;
  programId: string;
  eventId: string;
  stripeLink?: string;
}

interface ProgramTimelineProps {
  events: ProgramEvent[];
}

const ProgramTimeline: React.FC<ProgramTimelineProps> = ({ events }) => {
  const { t } = useTranslation(); // ✅ Import translation function

  console.log("Events received in ProgramTimeline:", events); // Debugging log

  const handleBuyNow = (stripeLink?: string) => {
    if (stripeLink) {
      console.log("Redirecting to:", stripeLink); // Debugging log
      window.location.href = stripeLink; // Redirect to Stripe checkout
    }
  };

  const today = new Date();
  today.setHours(0, 0, 0, 0); // Normalize today’s date

  return (
    <div className="program-timeline">
      <h1 className="program-timeline-title">{t('program_schedule')}</h1>

      {events.map((event) => {
        // ✅ Use `dateOfEvent` for correct comparison
        const eventDate = new Date(event.dateOfEvent);
        eventDate.setHours(0, 0, 0, 0); // Normalize event date

        const isPastEvent = eventDate < today; // ✅ Check if event is in the past

        console.log(`Event: ${event.title} - DateOfEvent: ${event.dateOfEvent} - Past: ${isPastEvent}`); // Debugging

        return (
          <div key={event.eventId} className={`program-timeline-item ${isPastEvent ? 'past-event' : ''}`}>
            {/* Left Section: Date and Time */}
            <div className="timeline-date">
              <div style={{ display: 'flex', justifyContent: 'end' }}>
                <LocationBadge location={event.location} link={event.locationLink} />
              </div>
              <p className="timeline-day">{event.date}</p> {/* Still using `date` for display */}
              <p className="timeline-time">{event.time || t('tbd')}</p>
            </div>

            {/* Vertical Line and Marker */}
            <div className="timeline-line">
              <img src={Marker} alt="Timeline Marker" className="timeline-marker" />
            </div>

            {/* Event Content */}
            <div className="timeline-content">
              <div className="event-header">
                <div className="event-title">
                  <h3 className="event-title">{event.title}</h3>
                </div>
              </div>

              <p className="event-description">{event.description || t('no_description')}</p>

              <div style={{ display: 'flex', gap: '20px' }}>
                <Link
                  to={`/program/${event.programId}/event/${event.eventId}`}
                  className="lesson-button"
                  onClick={() => console.log(`Event ${event.eventId} link: /program/${event.programId}/event/${event.eventId}`)}
                >
                  {t('learn_more')}
                </Link>

                {event.stripeLink && !isPastEvent && ( // ✅ Disable "Buy Now" for past events
                  <SmallGradientButton
                    width="102px"
                    onPress={() => {
                      console.log("Button in ProgramTimeline Clicked!"); // ✅ Debugging log
                      handleBuyNow(event.stripeLink);
                    }}
                  >
                    {t('buy_now')}
                  </SmallGradientButton>
                )}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ProgramTimeline;
